<template>
  <div class="titan_account_detail">
    <div class="titan_account_detail_top flex_display">
      <div class="titan_account_detail_profile flex_display">
        <div class="titan_account_detail_photo_container">
          <div class="titan_account_detail_photo flex_display">
            <img src="../../../assets/image/edward&cardy.png" class="portraits flex_display_centered_child_horizontal">
          </div>
          <div class="titan_account_detail_action_dropdown flex_display">
            <button class="neon_btn neon_btn_primary neon_btn_default flex_display_centered_child_horizontal">Actions</button>
          </div>
        </div>
        <div class="titan_account_detail_information">
          <div class="titan_account_detail_information_name"><span>Edward Shen</span></div>
          <div class="titan_account_detail_information_organization"><span>The Pokémon Company</span></div>
          <div class="titan_account_detail_information_phone"><i class="fas fa-phone information_icon" aria-hidden="true"></i><span>95279527</span></div>
          <div class="titan_account_detail_information_email"><i class="fas fa-laptop information_icon" aria-hidden="true"></i><span>smyxhlyx@pokemon.com</span></div>
        </div>
      </div>
      <div class="titan_account_detail_actions">
        <textarea></textarea>
      </div>
    </div>
    <div class="titan_account_detail_sections flex_display">
      <div class="titan_account_detail_section_list">
        <ul class="titan_account_detail_section_unordered remove_scroll_bar">
          <router-link v-for="(selectedSection, index) in sectionIncluded" v-bind:to="selectedSection.routerLink" :key="index" class="titan_account_detail_section_link">
            <li class="flex_display" v-bind:class="{titan_account_detail_section_bar_highlight: selectedSection.isCurrentSection}" v-on:click="switchSection(index)">
              <div class="titan_account_detail_section_name">
                {{selectedSection.sectionName}}
              </div>
              <div class="titan_account_detail_section_arrow">
              </div>
            </li>
          </router-link>
        </ul>
      </div>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'accountDetail',
    data () {
      return {
        sectionIncluded: [
          {
            sectionName: 'TimeLine',
            routerLink: '/timeLine',
            isCurrentSection: true
          },
          {
            sectionName: 'About',
            routerLink: '/',
            isCurrentSection: false
          },
          {
            sectionName: 'Membership',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Household Contacts',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Address',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Prospects',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Grants',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Invitations',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Activities',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Material & Letter Tracking',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Sent Email',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Donations',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Soft Credits',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Event Registration',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Survey Responses',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Relationships',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Employment History',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Notes',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Store Orders',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Volunteer Projects',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Receipts',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'MailChimp',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Peer-to-peer fundraising',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Solicited Transactions',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Wealth Screening',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'EventBrite',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Event Series',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Custom Object',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Workflows',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Data Privacy & Consent',
            routerLink: '',
            isCurrentSection: false
          },
          {
            sectionName: 'Contant Contact',
            routerLink: '',
            isCurrentSection: false
          }
        ],
        sectionExcluded: []
      }
    },
    methods: {
      switchSection: function (index) {
        for (var i = 0; i < this.sectionIncluded.length; i++) {
          if (i === index) {
            this.sectionIncluded[i].isCurrentSection = true
          } else {
            this.sectionIncluded[i].isCurrentSection = false
          }
        }
      }
    }
  }
</script>

<style scoped>
  .titan_account_detail {
    padding: 30px;
  }

  .titan_account_detail_photo_container {
    width: 140px;
  }

  .portraits {
    height: 84px;
    width: 84px;
    border-radius: 50%;
  }

  .titan_account_detail_action_dropdown {
    margin-top: 16px;
  }

  .titan_account_detail_information {
    width: 400px;
    text-align: left;
  }

  .titan_account_detail_information_name {
    font-family: Lato;
    font-weight: 400;
    font-size: 24px;
    color: #002D41;
  }

  .titan_account_detail_information_organization {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    color: #54698D;
  }

  .titan_account_detail_information_phone {
    font-family: Roboto;
    font-weight: 400;
    font-size: 16px;
    color: #0074D9;
    letter-spacing: -0.1px;
    text-align: left;
    margin-top: 16px;
  }

  .titan_account_detail_information_email {
    font-family: Roboto;
    font-weight: 400;
    font-size: 16px;
    color: #0074D9;
    letter-spacing: -0.1px;
    text-align: left;
    margin-top: 8px;
  }

  .information_icon {
    margin-right: 10px;
    color: #002D41;
  }

  .titan_account_detail_actions {
    width: 100%;
    height: 150px;
  }

  .titan_account_detail_actions textarea {
    resize: none;
    width: 100%;
    height: 150px;
  }

  .titan_account_detail_sections {
    padding: 32px;
  }

  .titan_account_detail_section_list {
    width: 235px;
  }

  .titan_account_detail_section_list ul {
    padding: 0px;
  }

  .titan_account_detail_section_list ul li {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #002D41;
    text-align: left;
    line-height: 14px;
    margin-bottom: 8px;
    list-style: none;
    cursor: pointer;
  }

  .titan_account_detail_section_list ul a.titan_account_detail_section_link {
    text-decoration: none;
  }

  .titan_account_detail_section_list ul a.titan_account_detail_section_link:hover {
    text-decoration: none;
  }

  .titan_account_detail_section_list ul li .titan_account_detail_section_name {
    width: 100%;
    padding: 8px 0px 8px 16px;
    background: #fff;
    color: #002D41;
  }

  .titan_account_detail_section_list ul li.titan_account_detail_section_bar_highlight .titan_account_detail_section_name {
    width: 100%;
    background: #002d41;
    color: #fff;
  }

  .titan_account_detail_section_list ul li.titan_account_detail_section_bar_highlight .titan_account_detail_section_arrow {
    width: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 8px solid #002D41;
    height: 100%;
    margin: auto;
  }

  .titan_account_detail_section_unordered {
    height: 600px;
    overflow: auto;
    margin-right: 1px;
    background: #fff;
  }
</style>

<style>
  .titan_account_detail_section_container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.20), 0 1px 5px 0 rgba(0,0,0,0.13);
  }

  .titan_account_detail_section_header {
    font-family: Lato;
    font-weight: 700;
    font-size: 20px;
    color: #002D41;
    text-align: left;
    padding: 28px 30px 24px 30px;
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
</style>



// WEBPACK FOOTER //
// src/modules/demo/components/AccountDetail.vue